import { IDecideNextStep } from "../../services/wizard/next-step-decider/next-step-decider.interface";
import { DemographicsStepComponent } from "../../wizard/wizard-steps/demographics-step/demographics-step.component";
import { WizardStepBase } from "./wizard-step-base.model";

export class DemographicsStep extends WizardStepBase {

  showOptionToNotProvideDemographicsInfo: boolean = true;

  constructor(id: string, name: string, path: string, nextStepDecider?: IDecideNextStep) {
    super(id, name, path, nextStepDecider);
    this.component = DemographicsStepComponent;
  }
}
